class SearchInput extends HTMLElement {

  constructor () {
    super()
    this.elements = {
      input: this.querySelector('[data-search-input-el="input"]'),
      closeDropdown: this.querySelector('[data-search-input-el="close-dropdown"]'),
      submit: this.querySelector('[data-search-input-el="submit"]')
    }

    this.externalElements = {
      dropdown: document.querySelector('[data-search-input-external-el="dropdown"]'),
      container: document.querySelector('[data-search-input-external-el="container"]'),
    }
  }
  connectedCallback () {
    this.attachEventListeners()
  }

  attachEventListeners () {
    if(this.elements.input) {
      this.elements.input.addEventListener('input', this.handleInput.bind(this))

      this.elements.input.addEventListener('focus', this.handleDropdownOpen.bind(this))
    }

    if(this.elements.closeDropdown) {
      this.elements.closeDropdown.addEventListener('click', this.handleDropdownClose.bind(this))
    }

    window.addEventListener('mobile-nav-drawer:ui:open', this.handleDropdownClose.bind(this))

    this.addEventListener('submit', this.handleFormSubmit.bind(this))
  }

  handleInput () {
    const searchTerm = this.elements.input.value.trim()

    window.theme.searchAutocomplete.eventBus.publish('searchAutoComplete:ui:term:updated', {
      term: searchTerm
    })

    this.elements.input.focus()
  }

  handleFormSubmit(event) {
    event.preventDefault();
    const searchTerm = this.elements.input.value.trim();

    // Redirect to the search results page with the search term as a query parameter
    if (searchTerm) {
      window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;
    }

    window.dataLayer.push({
      event: 'search',
      search_term: searchTerm,
    })
  }

  handleDropdownOpen () {
    window.theme.searchAutocomplete.eventBus.publish('searchAutoComplete:ui:dropdown:open')

    if( this.elements.closeDropdown) {
      this.elements.closeDropdown.classList.remove('hidden')
    }

    if( this.elements.submit) {
      this.elements.submit.classList.add('hidden')
    }

    this.elements.input.focus();

    document.body.style.overflow = 'hidden';

    this.publishEventToCloseMobileNavDrawer()

  }

  handleDropdownClose () {
    window.theme.searchAutocomplete.eventBus.publish('searchAutoComplete:ui:dropdown:close')

    if(this.elements.closeDropdown) {
      this.elements.closeDropdown.classList.add('hidden')
    }

    if(this.elements.submit) {
      this.elements.submit.classList.remove('hidden')
    }

    this.elements.input.blur();

    document.body.style.overflow = 'visible';
  }

  publishEventToCloseMobileNavDrawer () {
    const customEvent = new CustomEvent('mobile-nav-drawer:ui:close');
    window.dispatchEvent(customEvent);
  }

}

customElements.define('search-input', SearchInput)
